const getPostImage = (post) => {
  if (post.featuredImage != null && post.featuredImage.node.sourceUrl != null) {
    return post.featuredImage.node.sourceUrl
  }
}

export {
  getPostImage
}
